import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiFetch from "./utils/api";

// UserEditPage - similar to ProfilePage but loads and edits another user's record (admin only)
export default function UserEditPage() {
  const { user } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [desc, setDesc] = useState("");
  const [ut, setUt] = useState("");
  const [active, setActive] = useState(true);
  const [manager, setManager] = useState("");
  const [dailyHours, setDailyHours] = useState(7.5);
  const [shiftMon, setShiftMon] = useState(true);
  const [shiftTue, setShiftTue] = useState(true);
  const [shiftWed, setShiftWed] = useState(true);
  const [shiftThu, setShiftThu] = useState(true);
  const [shiftFri, setShiftFri] = useState(true);
  const [shiftSat, setShiftSat] = useState(false);
  const [shiftSun, setShiftSun] = useState(false);
  const [utOptions, setUtOptions] = useState([]);
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await apiFetch(`/api/users/${encodeURIComponent(user)}`);
        if (!mounted) return;
        if (res && res.user) {
          const u = res.user;
          setDesc(u.desc || "");
          setUt(u.ut || "");
          setActive(typeof u.active !== "undefined" ? u.active : true);
          setManager(u.manager || "");
          setDailyHours(typeof u.dailyHours === "number" ? u.dailyHours : 7.5);
          setShiftMon(!!u.shiftMon);
          setShiftTue(!!u.shiftTue);
          setShiftWed(!!u.shiftWed);
          setShiftThu(!!u.shiftThu);
          setShiftFri(!!u.shiftFri);
          setShiftSat(!!u.shiftSat);
          setShiftSun(!!u.shiftSun);
        }
      } catch (e) {
        // ignore
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    (async () => {
      try {
        const ut = await apiFetch("/api/utcodes");
        const mg = await apiFetch("/api/managers");
        if (mounted) {
          setUtOptions(ut && ut.utCodes ? ut.utCodes : []);
          setManagers(mg && mg.managers ? mg.managers : []);
        }
      } catch (e) {}
    })();

    return () => (mounted = false);
  }, [user]);

  const save = async (e) => {
    e && e.preventDefault();
    setStatus("saving");
    try {
      const body = {
        desc,
        ut: ut || null,
        active,
        manager: manager || null,
        dailyHours,
        Shift_Mon: shiftMon,
        Shift_Tue: shiftTue,
        Shift_Wed: shiftWed,
        Shift_Thu: shiftThu,
        Shift_Fri: shiftFri,
        Shift_Sat: shiftSat,
        Shift_Sun: shiftSun,
      };
      await apiFetch(`/api/users/${encodeURIComponent(user)}`, {
        method: "PUT",
        body: JSON.stringify(body),
      });
      setStatus("saved");
      setTimeout(() => navigate("/settings"), 700);
    } catch (e) {
      setStatus("error");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Edit user: {user}</h2>
      <form onSubmit={save}>
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}
        >
          <div>
            <label>Full name</label>
            <br />
            <input value={desc} onChange={(e) => setDesc(e.target.value)} />
          </div>
          <div>
            <label>Role</label>
            <br />
            <select value={ut} onChange={(e) => setUt(e.target.value)}>
              <option value="">(none)</option>
              {utOptions.map((u) => (
                <option key={u} value={u}>
                  {u}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>Manager</label>
            <br />
            <select
              value={manager}
              onChange={(e) => setManager(e.target.value)}
            >
              <option value="">(none)</option>
              {managers.map((m) => (
                <option key={m.code} value={m.code}>
                  {m.desc}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <label>Active</label>
            <input
              type="checkbox"
              checked={active}
              onChange={(e) => setActive(!!e.target.checked)}
            />
          </div>
          <div>
            <label>Daily hours</label>
            <br />
            <input
              type="number"
              value={dailyHours}
              onChange={(e) => setDailyHours(Number(e.target.value))}
            />
          </div>
        </div>
        <div style={{ marginTop: 12 }}>
          <button type="submit">Save</button>
          <button
            type="button"
            onClick={() => navigate("/settings")}
            style={{ marginLeft: 8 }}
          >
            Cancel
          </button>
          {status === "saved" && <span style={{ marginLeft: 8 }}>Saved</span>}
          {status === "error" && (
            <span style={{ marginLeft: 8, color: "darkred" }}>
              Error saving
            </span>
          )}
        </div>
      </form>
    </div>
  );
}
